// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__bcMU- {
  height: 36px;
  min-width: 36px;
  color: white;
  background-color: #454545;
  border-radius: 4px;
  gap: 0.5rem;
  transition: 0.2s;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Button_button__bcMU-:hover {
  background-color: #333333;
}
.Button_button__bcMU-:active {
  background-color: black;
}
.Button_button__bcMU-:disabled {
  background-color: lightgray;
  cursor: not-allowed;
}
.Button_button__bcMU-[data-style=RED] {
  background-color: #dc3545;
}
.Button_button__bcMU-[data-style=RED]:hover {
  background-color: #c42f3e;
}
.Button_button__bcMU-[data-style=RED]:active {
  background-color: #ad2f3c;
}
.Button_button__bcMU-[data-style=RED]:disabled {
  background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/Buttons/Button.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,uBAAA;AAAJ;AAGE;EACE,2BAAA;EACA,mBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAII;EACE,yBAAA;AAFN;AAII;EACE,2BAAA;AAFN","sourcesContent":[".button {\n  height: 36px;\n  min-width: 36px;\n  color: white;\n  background-color: #454545;\n  border-radius: 4px;\n  gap: 0.5rem;\n  transition: 0.2s;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.button:hover {\n  background-color: #333333;\n}\n.button:active {\n  background-color: black;\n}\n.button:disabled {\n  background-color: lightgray;\n  cursor: not-allowed;\n}\n.button[data-style=RED] {\n  background-color: #dc3545;\n}\n.button[data-style=RED]:hover {\n  background-color: #c42f3e;\n}\n.button[data-style=RED]:active {\n  background-color: #ad2f3c;\n}\n.button[data-style=RED]:disabled {\n  background-color: lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__bcMU-`
};
export default ___CSS_LOADER_EXPORT___;
